export default __webpack_public_path__ + "static/media/send.6eba4f60.svg";